import React, { useEffect, useState, useRef } from 'react';
import '../designcss/skillsectioncss.css';

const SkillBar = ({ skill, level, color, delay }) => {
  const [width, setWidth] = useState(0);
  const skillRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setWidth(level);
        }
      },
      { threshold: 0.5 }
    );

    if (skillRef.current) observer.observe(skillRef.current);

    return () => {
      if (skillRef.current) observer.unobserve(skillRef.current);
    };
  }, [level]);

  return (
    <div className="skill-wrapper" ref={skillRef}>
      <span className="skill-name">{skill}</span>
      <div
        className="skills"
        style={{
          width: `${width}%`,
          background: `linear-gradient(90deg, ${color} 0%, ${color}80 100%)`,
          transitionDelay: delay,
        }}
      ></div>
    </div>
  );
};

const SkillSection = () => {
  const skills = [
    { skill: 'Python3', level: 100, color: '#e6e462', delay: '1.2s' },
    { skill: 'C++', level: 85, color: '#62d6e6', delay: '0.8s' },
    { skill: 'JavaScript', level: 65, color: '#f44336', delay: '0.4s' },
    { skill: 'PHP', level: 75, color: '#808080', delay: '0.6s' },
    { skill: 'Rust', level: 20, color: '#62d6e6', delay: '1.4s' },
    { skill: 'HTML', level: 95, color: '#04AA6D', delay: '0s' },
    { skill: 'CSS', level: 90, color: '#2196F3', delay: '0.2s' },
    { skill: 'C', level: 45, color: '#e662d0', delay: '1s' },
  ];

  return (
    <div className="skill-section">
      <h2></h2>
      <div className="skillcontainer horizontal-scroll">
        {skills.map((s, idx) => (
          <SkillBar
            key={idx}
            skill={s.skill}
            level={s.level}
            color={s.color}
            delay={s.delay}
          />
        ))}
      </div>
    </div>
  );
};

export default SkillSection;
